"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const alliances = [{
  name: "NVIDIA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/nvidia_partner_logo.png"
}, {
  name: "CoreWeave",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/coreweave_partner_logo.png"
}, {
  name: "Vertiv",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/vertiv_partner_logo.png"
}, {
  name: "AMD",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/amd_partner_logo.png"
}, {
  name: "Supermicro",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/supermicro_partner_logo.png"
}, {
  name: "TSMC",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/tsmc_partner_logo.png"
}, {
  name: "Arista",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/arista_partner_logo.png"
}, {
  name: "Equinix",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587878/img/equinix_partner_logo.png"
}];
export default function StrategicAlliances() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}